import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Login from './pages/Auth/Login';
import Logout from './pages/Auth/Logout';
import Products from './pages/Product/Products';
import Transactions from './pages/Transaction/Transactions';
import Transaction from './pages/Transaction/Transaction';

const Routes = () => {
  return (
    <Switch>
      <Route path="/login" exact component={Login} />
      <Route path="/logout" exact component={Logout} />
      <Route path="/product" exact component={Products} />
      <Route path="/transaction" exact component={Transactions} />
      <Route path="/transaction/:id" exact component={Transaction} />
      <Redirect to="/product" />
    </Switch>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.js